import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";

type ThemeProp = {
    children: JSX.Element
}

export enum InstitucionalPalette {
    PRIMARY = '#223265',
    SECONDARY = '#29abe2',
    THIRD = '#707070',
    DREAM = '#F2F2F2'
}

export enum FacultadPalette {
    FCV_PRIMARY = '#54A020',
    FCNM_PRIMARY = '#3E297B',
    FICT_PRIMARY = '#394E28',
    FIEC_PRIMARY = '#7196AB',
    FIMCM_PRIMARY = '#238EA3',
    ESPAE_PRIMARY = '#F29148',
    FIMCP_PRIMARY = '#005CA6',
    FADCOM_PRIMARY = '#9F2270',
    FCSH_PRIMARY = '#FFD400'
}

export enum MedidasLayOut {
    WIDTH_SIDEBAR = "7vw",
    WIDTH_SIDEBAR_PHONE = "12vw",
    TOP_SIDEBAR = "10vh",
    LEFT_SIDEBAR = "0.5vw",
}

export enum PalettePreferencia {
    PREFERENCIA_1 = "#00B5FF",
    PREFERENCIA_2 = "#0098FF",
    PREFERENCIA_3 = "#0080FF",
}

export enum PaletteGrupos {
    GRUPO_1 = "#5BB32D",
    GRUPO_2 = "#0090A4",
    GRUPO_3 = "#4844A4",
    GRUPO_4 = "#FF8B00",
    ERROR = "#00B5FF"
}

export enum themePalette {
    PRIMARY = '#1976d2',
    PRIMARY_HOVER = '#115293',
    BG = "#12181b",
    BGWHITE = "#FFFFFF",
    BGTRANSPARENT = "transparent",
    BG_SIDEBAR = "#EAEBF0",
    COLOR_SIDEBAR_ICON = "#002755",
    NAVCOLOR = "#223265",
    FOOTERCOLOR = "#A3A3A3",
    BUTTONOK = "#6CC427",
    BUTTONYELLOW = "#EEC427",
    BONDIBLUE = "#009EB7",
    LIGHTBLUE = "#35B5E5",
    CHAMBRAY = "#114B8A",
    GAINSBORO = "#DCDCDC",
    WHITESMOKE = "F5F5F5",
    FONT_GLOBAL = "'Roboto', sans-serif",
    FONT_TITLE = "'Roboto', sans-serif",
    FONT_COLOR_LIGHTBLUE = '#2BC1FF',
    COLOR_INSCRIPCION = '#EEC427',
    COLOR_POSTULACION = '#6CC427',
    COLOR_ACEPTACION = '#28BED1',
    COLOR_CONSULTA = '#FF938C',
    COLOR_FONT_FOOTER = '#7C9EDE',
    MARIAN_BLUE = '#2B4593'
}

export enum themePaletteArea {
    AREA_ING_CIENCIA_1 = '#00B5FF',
    AREA_ING_CIENCIA_2 = '#425CC7',
    AREA_ING_CIENCIA_3 = '#472E87',
    AREA_CIENCIA_BIO = '#67A200',
    AREA_EDU_COMERCIAL = '#CDA315',
    AREA_ARTE = '#BF309B',
    AREA_HUMANIDADES = '#DEAE6D',
    AREA_SERVICIOS = '#FFC94B',
    AREA_SALUD = '#00BE7F',
}

export enum themePaletteEstados {
    APROBADO = '#2329A4',
    RECHAZADO = '#C91616',
    ENVIADO = '#FF0000',
    PUBLICADO = '#1E9A92',
}

const theme = createTheme({
    palette: {
        mode: "light",
        background: {
            default: themePalette.BGWHITE,
        },
        primary: {
            main: InstitucionalPalette.PRIMARY,
        },
        secondary: {
            main: InstitucionalPalette.SECONDARY,
        },
    },
    typography: {
        fontFamily: themePalette.FONT_GLOBAL,
    },
    components: {
        MuiButton: {
            defaultProps: {
                style: {
                    textTransform: "none",
                    boxShadow: "none",
                    borderRadius: "2em",
                    color: themePalette.BGWHITE,
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                InputLabelProps: {
                    style: {
                        color: InstitucionalPalette.PRIMARY, // Color específico para el texto del label
                        fontWeight: 'bold', // Negrita
                    },
                },
            }
        },
        MuiInputLabel: {
            defaultProps: {
                style: {
                    color: InstitucionalPalette.PRIMARY, // Color específico para el texto del label
                    fontWeight: 'bold', // Negrita
                },
            }
        },
        MuiFormControlLabel: {
            defaultProps: {
                style: {
                    color: InstitucionalPalette.PRIMARY, // Color específico para el texto del label
                    fontWeight: 'bold', // Negrita
                },
            }
        },
        MuiTypography: {
            defaultProps: {
                style: {
                    fontWeight: 'bold',
                }
            }
        }
    }
})

export const ThemeConfig: React.FC<ThemeProp> = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
}